import script from "./StatusBar.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusBar.vue?vue&type=script&setup=true&lang=js"

import "./StatusBar.vue?vue&type=style&index=0&id=12a9cfe7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12a9cfe7"]])

export default __exports__